import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToastService } from '@shared/modules/toast/services/toast.service';

@Component({
  selector: 'app-toast-redirect',
  templateUrl: './toast-redirect.component.html',
  styleUrls: ['./toast-redirect.component.scss']
})
export class ToastRedirectComponent implements OnInit {
  @Input() public toast$: any;

  constructor(private toastService: ToastService, private router: Router) {}

  // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method
  ngOnInit() {}

  close() {
    this.toastService.removeToast(this.toast$);
  }
  redirect() {
    this.router.navigate(['apps/ticketing/list']).then(r => {});
  }
}
